import { MotifCard, MotifCardBody, MotifCardHeader } from '@ey-xd/motif-react';
import WorkspaceHeaderTabs from '../molecules/WorkspaceHeaderTabs';
import React, { useEffect } from 'react';
import WorkspaceCyberOverview from '../molecules/WorkspaceCyberOverview';
import WorkspaceChats from '../molecules/WorkspaceChats';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useParams } from 'react-router-dom';
import WorkspaceDocs from '../molecules/WorkspaceDocs';
import WorkspaceReports from '../molecules/WorkspaceReports';

interface Props {
}

const menus = [
    "Overview",
    "Chat",
    "Docs",
    "RFP Response",
]
const WorkspaceDetails: React.FC<Props> = (props) => {
    const { state } = useLocation();
    const { access } = useSelector((state: any) => state.user);

    const dispatch = useDispatch();
    let selectConversations = useSelector((state: any) => state.conversations);
    const params = useParams();
    
    useEffect(() => {
        if(access.read === false) return;
        const { workspaceId, chatId } = params;
        dispatch({
            type: "GET_WORKSPACE_OVERVIEW",
            payload: {
                workspaceId
            }
        })
        dispatch({
            type: "GET_WORKSPACE_DOCUMENTS",
            payload: {
                workspaceId
            }
        })
        dispatch({
            type: "GET_WORKSPACE_REPORTS",
            payload: {
                workspaceId
            }
        })
    }, [access])

    useEffect(() => {
        if(access.read === false) return;
        const { chatId } = params;
        dispatch({
            type: 'CLEAR_CONVERSATION_CHATS', payload: {
                notClearCategory: true
            }
        });
        dispatch({
            type: "GET_WORKSPACE_CHATS",
            payload: {
                chatId
            }
        })
    }, [selectConversations?.conversationCategory, access])

    const [activeTab, setActiveTab] = React.useState(state?.initial === "chat" ? 1 : 0);
    if(access.read === false) {
        return <p className="mt-5 text-center font-bold">Read access denied</p>
    }
    return (
        <div className="flex flex-col min-h-full m-3">
            <MotifCard className="!bg-[transparent]">
                <MotifCardHeader className="!py-0 workspace-destails-tabs-container" style={{ borderBottom: "1px solid #ffffff26" }}>
                    <div className="flex gap-10 items-center">
                        <h5 className="font-bold">
                            Cyber Workspace
                        </h5>
                        <WorkspaceHeaderTabs menus={menus} active={activeTab} setActive={setActiveTab} />
                    </div>
                </MotifCardHeader>
                <MotifCardBody>
                    {activeTab === 0 && <WorkspaceCyberOverview />}
                    {activeTab === 1 && <WorkspaceChats />}
                    {activeTab === 2 && <WorkspaceDocs />}
                    {activeTab === 3 && <WorkspaceReports />}
                </MotifCardBody>
            </MotifCard>
        </div>
    );
};
export default WorkspaceDetails;